module.exports = require('./lib/effects')


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-saga/effects.js
 ** module id = 38
 ** module chunks = 0
 **/